module.exports = __webpack_public_path__ + "img/dink-white-bedroom-2.9d3ffbdc.jpeg";